export default __webpack_public_path__ + "locales/ko-KR/People.json?hash=140cafe5027b220cfde0921e4c6a4689";